import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import MonthlyIncome from "@/pages/MonthlyIncome";
import Investments from "@/pages/Investments";
import InvestmentDetail from "@/pages/InvestmentDetail";
import AddInvestment from "@/pages/AddInvestment";
import LoanTracker from "@/pages/LoanTracker";
import CafePnL from "@/pages/CafePnL";
import Partners from "@/pages/Partners";
import Reports from "@/pages/Reports";
import CashBook from "@/pages/CashBook";
import BillsPage from "@/pages/Bills";
import Masters from "@/pages/Masters";
import UsersPage from "@/pages/Users";
import Performance from "@/pages/Performance";
import CashEntry from "@/pages/CashEntry";
import NewBill from "@/pages/NewBill";
import Documents from "@/pages/Documents";
import Compliance from "@/pages/Compliance";
import ComplianceCalendar from "@/pages/ComplianceCalendar";
import Reminders from "@/pages/Reminders";
import PaymentAdvices from "@/pages/PaymentAdvices";
import Settings from "@/pages/Settings";
import MarketValuationReport from "@/pages/MarketValuationReport";
import BulkNav from "@/pages/BulkNav";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="monthly-income" element={<MonthlyIncome />} />
              <Route path="investments" element={<Investments />} />
              <Route path="investments/new" element={
                <ProtectedRoute roles={["admin", "accounts"]}>
                  <AddInvestment />
                </ProtectedRoute>
              } />
              <Route path="investments/:id" element={<InvestmentDetail />} />
              <Route path="loans" element={<LoanTracker />} />
              <Route path="cafe" element={<CafePnL />} />
              <Route path="cash-book" element={<CashBook />} />
              <Route path="receipts/new" element={
                <ProtectedRoute roles={["admin", "accounts"]}><CashEntry direction="in" /></ProtectedRoute>
              } />
              <Route path="payments/new" element={
                <ProtectedRoute roles={["admin", "accounts"]}><CashEntry direction="out" /></ProtectedRoute>
              } />
              <Route path="bills" element={<BillsPage kind="bill" />} />
              <Route path="bills/new" element={
                <ProtectedRoute roles={["admin", "accounts"]}><NewBill kind="bill" /></ProtectedRoute>
              } />
              <Route path="invoices" element={<BillsPage kind="invoice" />} />
              <Route path="invoices/new" element={
                <ProtectedRoute roles={["admin", "accounts"]}><NewBill kind="invoice" /></ProtectedRoute>
              } />
              <Route path="masters" element={<Masters />} />
              <Route path="performance" element={<Performance />} />
              <Route path="documents" element={<Documents />} />
              <Route path="compliance" element={<Compliance />} />
              <Route path="compliance/calendar" element={<ComplianceCalendar />} />
              <Route path="compliance/reminders" element={<Reminders />} />
              <Route path="compliance/advices" element={<PaymentAdvices />} />
              <Route path="settings" element={<ProtectedRoute roles={["admin"]}><Settings /></ProtectedRoute>} />
              <Route path="users" element={
                <ProtectedRoute roles={["admin"]}>
                  <UsersPage />
                </ProtectedRoute>
              } />
              <Route path="partners" element={<Partners />} />
              <Route path="reports" element={<Reports />} />
              <Route path="insights" element={<Reports />} />
              <Route path="market-valuation" element={<MarketValuationReport />} />
              <Route path="market-valuation/bulk-nav" element={
                <ProtectedRoute roles={["admin", "accounts"]}><BulkNav /></ProtectedRoute>
              } />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
